import { zodResolver } from "@hookform/resolvers/zod"
import * as React from "react"
import { useForm } from "react-hook-form"
import { Link } from "react-router-dom"
import { z } from "zod"
import { authApi } from "@/api/auth"
import { Alert, AlertDescription } from "@/components/ui/alert"
import { Button } from "@/components/ui/button"
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from "@/components/ui/card"
import { Input } from "@/components/ui/input"
import { Label } from "@/components/ui/label"

const schema = z.object({ email: z.string().email("Geçerli bir e-posta girin.") })
type FormValues = z.infer<typeof schema>

export function ForgotPasswordPage() {
  const [done, setDone] = React.useState<string | null>(null)
  const form = useForm<FormValues>({ resolver: zodResolver(schema), defaultValues: { email: "" } })

  async function onSubmit(values: FormValues) {
    const r = await authApi.forgotPassword(values)
    setDone(r.message)
  }

  return (
    <Card>
      <CardHeader>
        <CardTitle>Şifremi unuttum</CardTitle>
        <CardDescription>E-posta adresine sıfırlama bağlantısı göndereceğiz.</CardDescription>
      </CardHeader>
      <CardContent>
        {done ? (
          <Alert>
            <AlertDescription>{done}</AlertDescription>
          </Alert>
        ) : (
          <form className="space-y-4" onSubmit={form.handleSubmit(onSubmit)} noValidate>
            <div className="space-y-1.5">
              <Label>E-posta</Label>
              <Input type="email" autoComplete="email" {...form.register("email")} />
              {form.formState.errors.email && (
                <p className="text-xs text-destructive">{form.formState.errors.email.message}</p>
              )}
            </div>
            <Button type="submit" className="w-full" disabled={form.formState.isSubmitting}>
              Gönder
            </Button>
            <p className="text-center text-sm">
              <Link to="/login" className="text-muted-foreground hover:underline">
                Giriş sayfasına dön
              </Link>
            </p>
          </form>
        )}
      </CardContent>
    </Card>
  )
}
